<template>
  <div
    :class="
      getStyleName({
        active: active || overActive,
        move: moveActive,
        click: disabled
      })
    "
    @mousedown.stop="handleMove"
    @mouseover.stop="handleOver"
    @mouseout.stop="handleOut"
    :style="styleName"
  >
    <div :class="getStyleName('wrapper')" ref="wrapper">
      <template v-for="(item, index) in rangeList">
        <div
          :class="getStyleName('range', [item.classname])"
          :key="index"
          v-if="active"
          :style="[styleRangeName, getRangeStyle(item.classname)]"
          @mousedown.stop="rangeMove($event, item.classname)"
        ></div>
      </template>

      <div :class="getStyleName('item')" ref="item">
        <slot></slot>
      </div>
      <div :class="getStyleName('mask')" v-if="!disabled && mask"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "draggable",
  props: {
    mask: {
      type: Boolean,
      default: true
    },
    scale: {
      type: Number,
      default: 1
    },
    resize: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    zIndex: {
      type: [Number, String],
      default: 1
    },
    left: {
      type: Number,
      default: 0
    },
    top: {
      type: Number,
      default: 0
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  data() {
    return {
      ELEMENT: "__",
      MODS: "--",
      baseWidth: 0,
      baseHeight: 0,
      baseLeft: 0,
      baseTop: 0,
      children: {},
      moveActive: false,
      overActive: false,
      rangeActive: false,
      active: false,
      keydown: null,
      rangeList: [
        {
          classname: "left"
        },
        {
          classname: "right"
        },
        {
          classname: "top"
        },
        {
          classname: "bottom"
        },
        {
          classname: "top-left"
        },
        {
          classname: "top-right"
        },
        {
          classname: "bottom-left"
        },
        {
          classname: "bottom-right"
        }
      ]
    };
  },
  computed: {
    scaleVal() {
      return this.scale;
    },
    styleLineName() {
      return {
        borderWidth: this.setPx(this.scaleVal)
      };
    },
    styleRangeName() {
      const calc = 10 * this.scaleVal;
      return {
        width: this.setPx(calc),
        height: this.setPx(calc)
      };
    },
    styleLabelName() {
      return {
        fontSize: this.setPx(18 * this.scaleVal)
      };
    },
    styleName() {
      return Object.assign(
        (() => {
          if (this.active) {
            return Object.assign(
              {
                zIndex: 9999
              },
              this.styleLineName
            );
          }
          return { zIndex: this.zIndex };
        })(),
        {
          top: this.setPx(this.baseTop),
          left: this.setPx(this.baseLeft),
          width: this.setPx(this.baseWidth),
          height: this.setPx(this.baseHeight)
        }
      );
    }
  },
  watch: {
    active(val) {
      if (val) {
        this.handleKeydown();
      } else {
        document.onkeydown = this.keydown;
      }
    },
    width(val) {
      this.baseWidth = this.getFixed(val) || this.children.offsetWidth;
    },
    height(val) {
      this.baseHeight = this.getFixed(val) || this.children.offsetHeight;
    },
    left(val) {
      this.baseLeft = this.getFixed(val);
    },
    top(val) {
      this.baseTop = this.getFixed(val);
    },
    baseWidth(val) {
      this.$refs.wrapper.style.width = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.width = this.setPx(val);
      }
    },
    baseHeight(val) {
      this.$refs.wrapper.style.height = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.height = this.setPx(val);
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    getFixed(val = 0, len = 2) {
      return Number(val.toFixed(len));
    },
    getObjType(obj) {
      var toString = Object.prototype.toString;
      var map = {
        "[object Boolean]": "boolean",
        "[object Number]": "number",
        "[object String]": "string",
        "[object Function]": "function",
        "[object Array]": "array",
        "[object Date]": "date",
        "[object RegExp]": "regExp",
        "[object Undefined]": "undefined",
        "[object Null]": "null",
        "[object Object]": "object"
      };
      if (obj instanceof Element) {
        return "element";
      }
      return map[toString.call(obj)];
    },
    deepClone(data) {
      var type = this.getObjType(data);
      var obj;
      if (type === "array") {
        obj = [];
      } else if (type === "object") {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === "array") {
        for (var i = 0, len = data.length; i < len; i++) {
          data[i] = (() => {
            if (data[i] === 0) {
              return data[i];
            }
            return data[i];
          })();
          if (data[i]) {
            delete data[i].$parent;
          }
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === "object") {
        for (var key in data) {
          if (data) {
            delete data.$parent;
          }
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    validatenull(val) {
      // 特殊判断
      if (val && parseInt(val) === 0) return false;
      const list = ["$parent"];
      if (
        val instanceof Date ||
        typeof val === "boolean" ||
        typeof val === "number"
      )
        return false;
      if (val instanceof Array) {
        if (val.length === 0) return true;
      } else if (val instanceof Object) {
        val = this.deepClone(val);
        list.forEach(ele => {
          delete val[ele];
        });
        for (var o in val) {
          return false;
        }
        return true;
      } else {
        if (
          val === "null" ||
          val == null ||
          val === "undefined" ||
          val === undefined ||
          val === ""
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    setPx(val) {
      var defval =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      if ((0, this.validatenull)(val)) val = defval;
      if ((0, this.validatenull)(val)) return "";
      val = val + "";
      if (val.indexOf("%") === -1) {
        val = val + "px";
      }
      return val;
    },
    prefix(name, mods) {
      if (typeof mods === "string") {
        return this.join(name, mods, this.MODS);
      }

      if (Array.isArray(mods)) {
        return mods.map(item => {
          return this.prefix(name, item);
        });
      }

      var ret = {};
      var that = this;
      Object.keys(mods || {}).forEach(function(key) {
        ret[name + that.MODS + key] = mods[key];
      });
      return ret;
    },
    join(name, el, symbol) {
      return el ? name + symbol + el : name;
    },
    getStyleName(el, mods) {
      var name = this.$options.name;

      if (el && typeof el !== "string") {
        mods = el;
        el = "";
      }
      el = this.join(name, el, this.ELEMENT);

      return mods ? [el, this.prefix(el, mods)] : el;
    },
    init() {
      this.children = this.$refs.item.firstChild;
      this.baseWidth = this.getFixed(this.width) || this.children.offsetWidth;
      this.baseHeight =
        this.getFixed(this.height) || this.children.offsetHeight;
      this.baseLeft = this.getFixed(this.left);
      this.baseTop = this.getFixed(this.top);
      this.keydown = document.onkeydown;
    },
    setLeft(left) {
      this.baseLeft = left;
    },
    setTop(top) {
      this.baseTop = top;
    },
    getRangeStyle(postion) {
      const calc = (10 * this.scaleVal) / 2;
      let result = {};
      let list = postion.split("-");
      list.forEach(ele => {
        result[ele] = this.setPx(-calc);
      });
      return result;
    },
    setOverActive(val) {
      this.overActive = val;
    },
    setActive(val) {
      this.active = val;
    },
    rangeMove(e, position) {
      if (this.disabled) return;
      //移动的方向
      let x, y;
      //移动的位置
      let xp, yp;
      //移动的正负
      let xc, yc;
      this.rangeActive = true;
      this.handleMouseDown();
      let disX = e.clientX;
      let disY = e.clientY;
      document.onmousemove = e => {
        this.moveActive = true;
        if (position === "right") {
          x = true;
          y = false;
        } else if (position === "left") {
          x = true;
          xp = true;
          xc = true;
          y = false;
        } else if (position === "top") {
          x = false;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "bottom") {
          x = false;
          y = true;
        } else if (position === "bottom-right") {
          x = true;
          y = true;
        } else if (position === "bottom-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
        } else if (position === "top-right") {
          x = true;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "top-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
          yp = true;
          yc = true;
        }
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        if (x) {
          let calc = left * this.step;
          if (xc) calc = -calc;
          if (xp) this.baseLeft = this.getFixed(this.baseLeft - calc);
          this.baseWidth = this.getFixed(this.baseWidth + calc);
        }
        if (y) {
          let calc = top * this.step;
          if (yc) calc = -calc;
          if (yp) this.baseTop = this.getFixed(this.baseTop - calc);
          this.baseHeight = this.getFixed(this.baseHeight + calc);
        }
      };
      this.handleClear();
    },
    handleOut() {
      this.overActive = false;
      this.$emit("out", {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleOver() {
      if (this.disabled) return;
      this.overActive = true;
      this.$emit("over", {
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMove(e) {
      if (this.disabled) return;
      this.active = true;
      this.handleMouseDown();
      let disX = e.clientX;
      let disY = e.clientY;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        this.baseLeft = this.getFixed(this.baseLeft + left * this.step);
        this.baseTop = this.getFixed(this.baseTop + top * this.step);
      };
      this.handleClear();
    },

    handleClear() {
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.handleMouseUp();
      };
    },
    handleKeydown() {
      document.onkeydown = event => {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        let step = 1 * this.step;
        if (e && e.keyCode == 38) {
          //上
          this.baseTop = this.getFixed(this.baseTop - step);
        } else if (e && e.keyCode == 37) {
          //左
          this.baseLeft = this.getFixed(this.baseLeft - step);
        } else if (e && e.keyCode == 40) {
          //下
          this.baseTop = this.getFixed(this.baseTop + step);
        } else if (e && e.keyCode == 39) {
          //右
          this.baseLeft = this.getFixed(this.baseLeft + step);
        }
        event.stopPropagation();
        this.$emit("blur", {
          width: this.baseWidth,
          height: this.baseHeight,
          left: this.baseLeft,
          top: this.baseTop
        });
        this.keydown && this.keydown(event);
      };
    },
    handleMouseDown(e) {
      this.moveActive = true;
      this.$emit("focus", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMouseUp() {
      this.moveActive = false;
      this.rangeActive = false;
      this.$emit("blur", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.draggable {
  $active__color: rgba(115, 170, 229, 0.5);
  padding: 10px;
  position: absolute;
  cursor: move;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  &__mask {
    width: 100%;
    height: 100%;
    border: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &--active {
    cursor: move;
    border: 1px dashed #09f;
    background-color: $active__color;
  }
  &--move {
    opacity: 0.6;
    background-color: $active__color;
  }
  &--click {
    cursor: pointer;
  }
  &__line {
    &--left {
      position: absolute;
      border-top: 1px dashed #09f;
      width: 10000px;
      height: 0;
      top: 0;
      transform: translateX(-100%);
    }
    &--top {
      position: absolute;
      border-left: 1px dashed #09f;
      width: 0;
      height: 10000px;
      left: 0;
      transform: translateY(-100%);
    }
    &--label {
      top: -5px;
      left: -8px;
      position: absolute;
      padding: 5px;
      transform: translate(-100%, -100%);
      color: #09f;
      font-size: 18px;
      white-space: nowrap;
      cursor: move;
    }
  }
  &__range {
    $calcheight: -6px;
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    z-index: 9999;
    background-color: #09f;
    &--left,
    &--right {
      &:hover {
        cursor: ew-resize;
      }
      top: 50%;
      transform: translateY(-50%);
    }
    &--left {
      left: $calcheight;
    }
    &--right {
      right: $calcheight;
    }
    &--top,
    &--bottom {
      &:hover {
        cursor: ns-resize;
      }
      left: 50%;
      transform: translateX(-50%);
    }
    &--top {
      top: $calcheight;
    }
    &--bottom {
      bottom: $calcheight;
    }
    &--bottom-right,
    &--top-left {
      &:hover {
        cursor: nwse-resize;
      }
    }
    &--bottom-left,
    &--top-right {
      &:hover {
        cursor: nesw-resize;
      }
    }
    &--top-right {
      top: $calcheight;
      right: $calcheight;
    }
    &--top-left {
      top: $calcheight;
      left: $calcheight;
    }
    &--bottom-right {
      bottom: $calcheight;
      right: $calcheight;
    }
    &--bottom-left {
      bottom: $calcheight;
      left: $calcheight;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myPlugin/Drage/drage.vue